import { render, staticRenderFns } from "./TitleScreen.vue?vue&type=template&id=e387aeec&lang=pug&"
import script from "./TitleScreen.vue?vue&type=script&lang=js&"
export * from "./TitleScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports